import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
    const { user, checked } = useAuth();
    if (!checked) {
        return (
            <div className="min-h-screen bg-[#050510] text-white flex items-center justify-center tech-label">
                Verifying session…
            </div>
        );
    }
    if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
    return children;
}
